export default __webpack_public_path__ + "static/Performance-49b986637e535f93db7bcf13cd5a8003.gif";